import { render, staticRenderFns } from "./JustCurrentFilters.vue?vue&type=template&id=01044f06"
import script from "./JustCurrentFilters.vue?vue&type=script&lang=js"
export * from "./JustCurrentFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports